module.exports = __webpack_public_path__ + "static/img/8.44ba751.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/sp/8.png
// module id = GqEG
// module chunks = 0